import angular from 'angular';
import RetailerReportsPageComponent from './retailer-reports-page-component';

export default angular.module('retailer-reports-page', []).component('retailerReportsPage', new RetailerReportsPageComponent());



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/components/retailer-reports-page/retailer-reports-page-module.js